import { Component, OnInit, NgZone } from '@angular/core';
import { Language } from 'src/core/utility/enums/enums';
import { LanguageSwitcherService } from '../services/language-switcher.service';
import { ListingBaseComponent } from 'src/core/sharepoint/model/listingbase-component';
import { RepositoryService } from 'src/core/sharepoint/services/repository';
import { TranslateService } from '@ngx-translate/core';
import { LoadingScreenService } from '../../loader/services/loader.service';
import { bidConstants } from 'src/shared/bid/models/bid-const';
import { MapperCONFIG } from 'src/core/sharepoint/model/mapper';
import { BidMapper } from 'src/shared/bid/models/bid-mapper';
import { SharepointService } from 'src/core/sharepoint/services/sharepoint.service';

@Component({
  selector: 'adahi-language-switcher',
  templateUrl: './language-switcher.component.html',
  providers:[  
    RepositoryService,
    SharepointService,
    { provide: MapperCONFIG, useClass: BidMapper }
  ]
})
export class LanguageSwitcherComponent extends ListingBaseComponent implements OnInit {

  selectedLanguage = Language[_spPageContextInfo.currentLanguage];
  languages = ['ar', 'en', 'fr'];
  
  constructor(private languageSwitcherService:LanguageSwitcherService,private repositoryService: RepositoryService, ngZone: NgZone, translate: TranslateService,public LoadingScreenService:LoadingScreenService) {
    super( ngZone, translate,LoadingScreenService);
   
  }
  
  ngOnInit() {
    
    this.translate.getTranslation(this.translate.defaultLang).subscribe((res) => {
      this.repositoryService.getItemsPaging(bidConstants.slash+ this.currenLanguage, this.translate.instant('bid.bidList'), bidConstants.camlQuery.AllBidList,this.onSuccessPaging, this.onError, this.onNoAvailableData);
    });
  }

  public LanguageSwitcher(selectedLanguage) {
    this.selectedLanguage=selectedLanguage;
    this.languageSwitcherService.LanguageSwitcher(selectedLanguage,this.onRedirect);
  }

  onSuccessPaging = (data:any) => {
    this.ngZone.run(() => {
       
    });
  }
  
  onError = (e) => {
    
    this.ngZone.run(() => {
       
       
    });

}
  onNoAvailableData = () => {
    this.ngZone.run(() => {
      let bidsMenuItem = document.querySelectorAll("li a[href*='Bids']");
      if (bidsMenuItem != null && bidsMenuItem.length > 0) {
        
        bidsMenuItem[0].setAttribute("style","display: none");
      }
    });
}

  onRedirect=()=>
    {
      
    }


  handleClick() {
    document.querySelectorAll('.ms-core-navigation .arrow').forEach(function (arrow) {
      (<HTMLElement>arrow).classList.remove('arrow-down');
      arrow.nextElementSibling.classList.remove('is-active');
      arrow.parentElement.classList.remove('is-active');
    });
  }

}
